<template>
  <!-- 业务范围 -->
  <div class="busines" style="text-align:center">
    <!-- banner -->
    <div class="banner flex-center">
      <img :src="banner" alt />
      <div class="content">
        <div class="name">{{title.name}}</div>
        <div class="serve mt20">{{title.top_title}}</div>
        <div class="slogan">{{title.next_title}}</div>
      </div>
    </div>

    <!-- 业务范围 -->
    <div class="business mb40 mt40">
      <div class="titleImg">
        <img src="../../static/img/home/biaoti_2.png" alt />
      </div>
      <div class="flex-center">
        <div class="W1200 flex-between">
          <div v-for="(item,index) in rangeList" :key="index" class="range_item"
            :style="{backgroundImage:'url('+ item.img+')'}">
            <div class="name">
              {{item.title}}
            </div>
            <div class="hover_item flex">
              <div>
                <div class="hover_item_logo"><img :src="item.logo" alt=""></div>
                <div class="hover_item_title">{{item.title}}</div>
                <div class="flex">
                  <div class="hover_item_line"></div>
                </div>
                <div class="flex">
                  <div class="hover_item_content">{{item.content}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们的优势 -->
    <div class="advantage flex-column-center">
      <div class="title">我们的优势</div>
      <div class="eng_title">ADVANTAGE</div>
      <div class="line"></div>
      <div class="advantage_list flex-around">
        <div class="advantage_item" v-for="(item,index) in advList" :key="index">
          <div class="flex-center advantage_item_img"><img :src="item.url" alt /></div>
          <div class="name">{{item.name}}</div>
        </div>
      </div>
    </div>

    <!-- 我们的优势2 -->
    <div class="bg">
      <div class="advantage flex-column-center  advantage1">
        <div class="title">我们的优势</div>
        <div class="eng_title">ADVANTAGE</div>
        <div class="line"></div>
        <div class="advantage_list1 flex-between W1200 mt50" style="flex-wrap:wrap;">
          <div class="advantage_item1 flex-column-center ml5 mt50" v-for="(item,index) in advList1" :key="index">
            <div style="width:108px;height:58px;" class="flex-center">
              <img :src="item.url" alt />
            </div>
            <div class="name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getHomeInfo,
    getBusiness,
    getNavList
  } from '../../api/apis.js'
  // import { getNavList } from "./api/apis";
  // import {getNavList} from '../../api/apis'
  export default {
    name: "busines",
    data() {
      return {
        banner: "",
        title: {},
        business: [],
        advList: [{
            url: require("../../static/img/busines/anquan.png"),
            name: "安全稳定"
          },
          {
            url: require("../../static/img/busines/tuandui.png"),
            name: "专业团队"
          },
          {
            url: require("../../static/img/busines/chuangxin.png"),
            name: "技术创新"
          },
          {
            url: require("../../static/img/busines/renzheng.png"),
            name: "行业认证"
          },
          {
            url: require("../../static/img/busines/cailiao.png"),
            name: "优质材料"
          }
        ],
        advList1: [{
            url: require("../../static/img/busines/chengshi.png"),
            name: "城市"
          },
          {
            url: require("../../static/img/busines/jianzhu.png"),
            name: "建筑"
          },
          {
            url: require("../../static/img/busines/daolu.png"),
            name: "道路"
          },
          {
            url: require("../../static/img/busines/qiaoliang.png"),
            name: "桥梁"
          },
          {
            url: require("../../static/img/busines/fanghong.png"),
            name: "防洪"
          },
          {
            url: require("../../static/img/busines/ranqi.png"),
            name: "燃气"
          },
          {
            url: require("../../static/img/busines/paishui.png"),
            name: "给排水"
          },
          {
            url: require("../../static/img/busines/yuanlin.png"),
            name: "园林"
          },
          {
            url: require("../../static/img/busines/shuidian.png"),
            name: "水力发电"
          },
          {
            url: require("../../static/img/busines/huodian.png"),
            name: "火力发电防洪"
          },
          {
            url: require("../../static/img/busines/jieneng.png"),
            name: "清洁能源"
          },
          {
            url: require("../../static/img/busines/huanbao.png"),
            name: "环保"
          }
        ],
        rangeList: [{
            logo: require('../../static/img/home/login1.png'),
            url: require('../../static/img/home/gongren.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "施工"
          },
          {
            logo: require('../../static/img/home/login2.png'),
            url: require('../../static/img/home/shizheng.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "市政工程"
          },
          {
            logo: require('../../static/img/home/login3.png'),
            url: require('../../static/img/home/chengshi.png'),
            title: "电力施工总承包",
            content: "指承揽与电能的生产、输送及分配有关的工程。包括火力发电、水力发电、核能发电、风电、太阳能及其它能源发电、输配电等工程及其配套工程",
            name: "城市及道路照明工程"
          }
        ]

      };
    },
    components: {},

    methods: {
      //获取首页展示信息
      initBu() {
        getBusiness().then(res => {

          this.title = res.title;
          this.rangeList = res.content;
        });
        getHomeInfo().then(res => {

          this.business = res.business;


          this.initBuiness(res.business);
        });

      },
      //转换business类容
      initBuiness(list) {
        let newList = this.rangeList;
        list.forEach((item, index) => {
          newList[index].url = item.img;
          newList[index].title = item.title;
          newList[index].content = item.content;
        });
        this.rangeList = newList;
      },

    },
    mounted() {
      getNavList().then(res => {
      let navBanner = [];
      let cate = [];
      let navList = [
        { id: 0, title: "首页", path: "/" },
        { id: 0, title: "业务范围", path: "/busines" },
        { id: 0, title: "公司简介", path: "/brief" },
        { id: 0, title: "工程案例", path: "/casecenter" },
        { id: 0, title: "新闻中心", path: "/newscenter" },
        { id: 0, title: "人才招聘", path: "/talent" },
        { id: 0, title: "联系我们", path: "/concat" }
      ];
      res.forEach((item, index) => {
        navList[index].id = item.id;
        navList[index].title = item.cate_name;
        navBanner[index] = item.cate_img;
        cate.push(item.next_cate);
      });
      this.banner = navBanner[1];
    })
      this.initBu();
    },
  };
  // 注册地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号
  // 办公地址：四川省成都市武侯区星狮路711号1栋2单元11层1104号
</script>
<style scoped lang="scss">
  .busines {
    margin-bottom: 205px;
  }

  .bg {
    background-image: url("../../static/img/busines/youshi.png");
  }

  .banner {
    position: relative;
    color: #ffffff;

    img {
      width: 100%;
    }

    .content {
      width: 1100px;
      height: 250px;
      position: absolute;
      top: 50%;
      margin-top: -130px;
      text-align: center;

      .name {
        font-size: 24px;
        line-height: 48px;
        padding: 0px 20px;
        border: 1px solid #ffffff;
        display: inline-block;
      }

      .serve {
        font-size: 48px;
        line-height: 64px;
      }

      .slogan {
        font-size: 24px;
        margin-top: 30px;
      }
    }

    .titleImg {
      margin-top: 50px;
    }

    .titleImg {
      img {
        width: 576px;
        height: 152px;
      }
    }
  }

  .advantage {
    .title {
      margin-top: 120px;
      font-size: 32px;
      color: rgba(51, 51, 51, 1);
      line-height: 42px;
    }

    .eng_title {
      font-size: 18px;
      color: #999999;
      line-height: 24px;
      margin-top: 10px;
    }

    .line {
      background-color: #999999;
      width: 50px;
      height: 3px;
      margin-top: 8px;
    }
  }

  .advantage1 {
    margin-top: 80px;
    padding-bottom: 100px;

    .title {
      margin-top: 56px;
      color: #ffffff;
    }

    .eng_title {
      color: #ffffff;
    }

    .line {
      background-color: #ffffff;
    }
  }

  .advantage_list {
    margin-top: 40px;
    width: 1000px;
  }

  .advantage_item {
    .advantage_item_img {
      width: 100%;
      height: 38px;
    }

    img {
      /* width: 48px; */
      height: 38px;
    }

    .name {
      margin-top: 10px;
      line-height: 24px;
      font-size: 18px;
      color: #333333;
    }
  }

  .advantage_item1:hover {
    background: rgba(255, 255, 255, 0.6);
  }

  .advantage_item1 {
    width: 170px;
    height: 180px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.4);

    .img {
      width: 108px;
      height: 68px;
      display: flex;
      opacity: 1;
    }

    .name {
      opacity: 1;
      color: #ffffff;
      margin-top: 24px;
      font-size: 18px
    }
  }

  .color_white {
    color: #ffffff !important;
  }




  /* 业务范围 */
  .range_item {
    width: 360px;
    height: 384px;
    position: relative;

    .name {
      font-size: 24px;
      height: 46px;
      width: 100%;
      position: absolute;
      bottom: 0px;
      text-align: center;
      line-height: 46px;
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.4);
      display: block;
    }

    .hover_item {
      width: 100%;
      height: 100%;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.4);
      display: none;
      color: #ffffff;

      .hover_item_logo {
        width: 100%;

        /* margin-top:30px; */
        img {
          width: 66px;
          height: 68px;
          margin-top: 30px;
        }
      }

      .hover_item_title {
        margin-top: 40px;
        font-size: 24px;
      }

      .hover_item_line {
        margin-top: 15px;
        width: 70px;
        height: 2px;
        background-color: #ffffff;
      }

      .hover_item_content {
        margin-top: 30px;
        width: 279px;
        height: 140px;
        font-size: 14px;
        line-height: 28px;
        overflow: hidden;
      }
    }
  }

  .range_item::before,
  .range_item::after {
    content: '';
    position: absolute;
    width: 284px;
    height: 17px;
    background-color: #F1F5F8;
    left: 39px;

  }

  .range_item::before {
    top: -17px;
  }

  .range_item::after {
    bottom: -17px;
  }

  .range_item:hover {
    .name {
      display: none;
    }

    .hover_item {
      display: block;
    }
  }

  .range_item:hover::after,
  .range_item:hover::before {
    background-color: #1584F5;
  }
</style>